import React from 'react'
import { useTranslation } from 'react-i18next'
import { InsightContentSettingType } from 'components/insightContent/types'
import { getPercentOfTotal } from 'components/insightContent/utils/utils'
import { PercentDisplay } from 'components/insightContent/visualization/Overview'
import useCrosstabData from 'components/widget/CrosstabWidgets/share/Crosstab/useCrosstabData'
import { resolveAverage, formatDifferenceOfAverage } from '../utils/averageResolver'
import resolveSum from '../utils/sumResolver'
import formatMentionsDisplay from '../../utils'
import { shouldShowAverageInformation } from '../utils/viewOptionUtils'

const SideLabel = ({
  detailSetting,
  widgetId,
  isAudienceQuery,
  selectedValue
}: {
  detailSetting: InsightContentSettingType
  widgetId: number
  isAudienceQuery: boolean
  selectedValue: number
}) => {
  const { t } = useTranslation()

  const { viewOption } = detailSetting
  const { crossTabs } = useCrosstabData(widgetId, isAudienceQuery)

  const count = formatMentionsDisplay(selectedValue)

  if (shouldShowAverageInformation(viewOption)) {
    const average = resolveAverage(detailSetting, crossTabs)

    return (
      <PercentDisplay
        count={count}
        sideLabel={t('diffOfRowAverage', {
          diff: formatDifferenceOfAverage(average, selectedValue, viewOption),
          interpolation: { escapeValue: false }
        })}
      />
    )
  }

  const sum = resolveSum(crossTabs)
  return (
    <PercentDisplay
      count={count}
      sideLabel={t('percentShareOfTopics', {
        percent: getPercentOfTotal(selectedValue, sum),
        interpolation: { escapeValue: false }
      })}
    />
  )
}

export default SideLabel
